import { t } from 'i18next';
import { getHoursAndMinutesFromMinutes } from '@/utils';
import { useUmsatzAbsatzZiele } from '@/domain/controlling/hooks';
import { useParams } from 'react-router-dom';
import { LabeledField } from './LabeledField';
import { LabeledTimeField } from './LabeledTimeField';
import { ZieleError } from './ZieleError';
import { formatNumber } from '../../utils';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import { toNumber } from '@/utils/toNumber/toNumber';
import dayjs from 'dayjs';

export function UmsatzZiele() {
  const { year, month } = useParams();
  const jahr = toNumber(year) ?? dayjs().get('year');
  const monat = toNumber(month) ?? dayjs().get('month') + 1;

  const {
    currentStandort: { id: standortId },
  } = useStandortContext();
  const { umsatzZiel, error } = useUmsatzAbsatzZiele(standortId, jahr, monat);

  return !error && umsatzZiel ? (
    <div className="flex flex-row px-5 py-4 justify-between">
      <LabeledField
        className="w-1/3"
        value={
          umsatzZiel.wert
            ? formatNumber(umsatzZiel.wert.amount.toString(), false)
            : undefined
        }
        currency={t('general.currency.EUR')}
        label={t('domain.controlling.umsatzplanung.ziele.umsatz')}
      />
      <LabeledField
        className="w-1/3"
        value={
          umsatzZiel.produktivitaet
            ? formatNumber(umsatzZiel.produktivitaet.amount.toString(), false)
            : undefined
        }
        currency={t('domain.controlling.umsatzplanung.units.€/Std.')}
        label={t('domain.controlling.umsatzplanung.ziele.produktivitaet')}
      />
      <LabeledTimeField
        className="w-1/3 border-l border-neutrals-300 pl-4"
        label={t('domain.controlling.umsatzplanung.ziele.zielstunden')}
        hours={
          umsatzZiel.stunden
            ? getHoursAndMinutesFromMinutes(umsatzZiel.stunden).hours
            : undefined
        }
        minutes={
          umsatzZiel.stunden
            ? getHoursAndMinutesFromMinutes(umsatzZiel.stunden).minutes
            : undefined
        }
      />
    </div>
  ) : (
    <div className="px-5 py-4">
      <ZieleError />
    </div>
  );
}
